import HttpService from '../../services/HttpService';
import ErrorSwitchCase from '../../services/ErrorHandlerService';
import { ADMIN_PATH } from '../../url';
const _axios = HttpService.getAxiosClient();

export const validateEmployeeMasterCsv = async (file) => {
  try {
    const formData = new FormData();
    formData.append('file', file);
    const response = await _axios.post(
      `${ADMIN_PATH}/employee-master-csv/validate`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } },
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data);
  }
};

export const submitEmployeeMasterCsv = async (file) => {
  try {
    const formData = new FormData();
    formData.append('file', file);
    const response = await _axios.post(
      `${ADMIN_PATH}/employee-master-csv/submit`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } },
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data);
  }
};

/**
 * Eligible Reporting Managers (active + senior-manager role) for selectors/filters.
 */
export const getEligibleReportingManagers = async () => {
  try {
    const response = await _axios.get(`${ADMIN_PATH}/reporting-managers`);
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data);
  }
};

/**
 * @param {object} [filters]
 * @param {string} [filters.status] ALL | ACTIVE | ARCHIVED
 * @param {string} [filters.leaveGroup] ALL | NONE | group name
 * @param {string} [filters.reportingManagerId] ALL | NONE | employee UUID
 * @param {string} [filters.joiningDateAfter] dd/mm/yyyy
 * @param {string} [filters.joiningDateBefore] dd/mm/yyyy
 * @param {string} [filters.careerStartDateAfter] dd/mm/yyyy
 * @param {string} [filters.careerStartDateBefore] dd/mm/yyyy
 * @param {string} [filters.internshipEndDateAfter] dd/mm/yyyy
 * @param {string} [filters.internshipEndDateBefore] dd/mm/yyyy
 */
const parseExportErrorBody = async (error) => {
  const data = error?.response?.data;
  if (data instanceof Blob) {
    try {
      const text = await data.text();
      if (text) {
        return JSON.parse(text);
      }
    } catch {
      // Fall through to status-based fallback below.
    }
  } else if (data && typeof data === 'object') {
    return data;
  }
  return {
    status: error?.response?.status,
    message: 'Failed to export employee CSV.',
  };
};

export const exportEmployeeMasterCsv = async (filters = {}) => {
  try {
    const params = {};
    Object.entries(filters).forEach(([key, value]) => {
      if (value == null) return;
      const trimmed = String(value).trim();
      if (!trimmed) return;
      if (key === 'status' && trimmed.toUpperCase() === 'ALL') return;
      if (key === 'leaveGroup' && trimmed.toUpperCase() === 'ALL') return;
      if (key === 'reportingManagerId' && trimmed.toUpperCase() === 'ALL') return;
      params[key] = trimmed;
    });
    const response = await _axios.get(
      `${ADMIN_PATH}/employee-master-csv/export`,
      { responseType: 'blob', params },
    );
    return { isError: false, data: response.data, status: response.status };
  } catch (error) {
    return ErrorSwitchCase(await parseExportErrorBody(error));
  }
};
